import { CodeLocation } from "./CodeLocation";
import TerminalLine from "./TerminalLine";

const findCodeLocationFromDetails = (details: string | null) => {
  const matches = details?.match(new RegExp("\\(<(.*)>, line ([0-9]+)\\)$"));
  if (!matches || matches.length !== 3) {
    return null;
  }
  return {
    cellId: matches[1],
    lineNumber: Number(matches[2]),
  };
};

/*
 * A traceback looks like this:
 *  <ipython-input-117-def8774d8de7> in iterateOneToFive(arr)
 *    1998 def iterateOneToFive(arr):
 *    1999     for i in range(5):
 * -> 2000         print(arr[i])
 *
 * IndexError: list index out of range
 */
const findCodeLocationFromTraceback = (traceback: string[]) => {
  let lineNumber: number | null = null;
  let cellId: string | null = null;

  for (let i = traceback.length - 1; i >= 0; i--) {
    const str = traceback[i];

    if (lineNumber == null && cellId == null) {
      const matches = str.match("\n-*> ([0-9]+) ");
      if (matches && matches.length === 2) {
        lineNumber = Number(matches[1]);
      }
    }

    if (lineNumber !== null && cellId == null) {
      const matches = str.match("<(ipython-input-[0-9]+.*?)>");
      if (matches && matches.length === 2) {
        cellId = matches[1];
      }
    }
  }

  if (lineNumber != null && cellId != null) {
    return { cellId, lineNumber };
  }
  return null;
};

const ANSI_ESCAPE_REGEX = /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
const stripAnsiEscapeCodes = (str: string) => {
  return str.replace(ANSI_ESCAPE_REGEX, "");
};

export default class TerminalError implements TerminalLine {
  readonly type = "error";
  readonly message: string = "";
  readonly details: string | null = null;
  readonly expandedDetails: string | null = null;
  readonly codeLocation: CodeLocation | null = null;

  constructor(
    readonly error: string | Error,
    details: string | null = null,
    traceback: string[] | null = null
  ) {
    if (error instanceof Error) {
      this.message = error.message;
      if (error.stack) {
        const lines = error.stack.split("\n");
        this.details = lines[0];
        this.expandedDetails = lines.slice(1).join("\n");
      }
    } else {
      this.message = error;
      this.details = details;
      this.codeLocation = findCodeLocationFromDetails(details);
      if (traceback != null) {
        traceback = traceback.map(str => stripAnsiEscapeCodes(str));
        this.expandedDetails = traceback.join("\n");

        this.codeLocation =
          this.codeLocation || findCodeLocationFromTraceback(traceback);
      }
    }
  }
}
